var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOccupant(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 251,
    viewBox: "0 0 250 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M215.35 118.745C215.22 137.415 215.08 156.074 214.97 174.734C185.06 191.984 155.13 209.265 125.22 226.515V159.325C155.25 145.825 185.31 132.285 215.35 118.745Z",
    fill: "#72D09A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.23 105.474V179.574L125.24 226.544V159.354L80.73 81.1644L36.23 105.474Z",
    fill: "#B2E8C5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.78 97.5847C25.27 100.205 30.74 102.845 36.23 105.465L80.73 81.1547C100.67 109.965 120.58 138.755 140.51 167.565C170.42 151.335 200.33 135.115 230.24 118.885C210.38 87.1448 190.55 55.3947 170.69 23.6547C140.71 36.9247 110.72 50.1947 80.73 63.4547C60.42 74.8447 40.1 86.2247 19.78 97.5847Z",
    fill: "#29A063"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.78 97.5845L36.23 105.464L80.73 81.1544L125.24 159.344L140.51 167.564L80.73 63.4745L19.78 97.5845Z",
    fill: "#72D09A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8099 116.305C76.1099 116.075 72.6099 114.955 69.2699 116.805C65.6899 118.805 64.9799 122.795 64.7099 124.275C63.9399 128.605 65.7699 132.445 66.4999 133.925C66.7299 134.405 66.9399 134.775 67.0799 135.025C68.9099 138.295 72.1799 141.825 72.2399 141.855L71.8899 146.845L73.5899 147.755V150.875L76.8199 154.125L73.1999 154.895L73.3399 160.095L76.8199 163.735L73.8599 164.605L73.9899 170.365L76.8399 172.825H73.2199L73.3599 177.235L77.7699 183.995L81.7899 181.915V152.705L83.0799 149.505C83.0799 149.505 85.5299 149.405 87.6899 147.505C88.1299 147.115 89.8199 145.575 90.6099 141.875C92.4199 133.595 87.3599 125.795 86.8399 125.025C83.5999 120.175 79.3899 117.595 76.8099 116.305Z",
    fill: "#F97E73"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M81.89 127.355C81.95 129.165 81.14 131.655 79.56 132.095C77.17 132.765 73.07 128.805 73.32 124.895C73.42 123.425 74.15 121.315 75.65 120.865C78 120.175 81.79 123.625 81.89 127.355Z",
    fill: "#B2E8C5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6699 183.515V154.245L79.8899 155.145V182.895L78.6699 183.515Z",
    fill: "#B2E8C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOccupant);
export default __webpack_public_path__ + "static/media/occupant.962a2508bf9374d430de6e5433f8b313.svg";
export { ForwardRef as ReactComponent };